var alertNotifications = {
	alert: {
		limitAbove: "Limite supérieure dépassée",
		limitBelow: "Limite inférieure dépassée"
	},
	closeBtn: "Fermer",
	openHistory: "Ouvrir l'historique des alertes"
};
var fr = {
	alertNotifications: alertNotifications
};

export { alertNotifications, fr as default };
